// extracted by mini-css-extract-plugin
module.exports = {"container":"navbar-module--container--16Xp2","logo":"navbar-module--logo--3jqlW","links":"navbar-module--links--3hd-k","navItem":"navbar-module--nav-item--2e7rX"};